import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { NavLink } from 'react-router-dom';
import { UserLogout, userTraversingToAct } from '../../Actions/UserActs';
import { GlobalStore } from '../../StateStores';
import { ReactSession } from 'react-client-session';
import { getLocalProfile, getUserProfile } from '../../Helpers/TokenServices';
import { toast } from 'react-toastify';

const ProfileDropdown = () => {
    const {authDispatch,authState:{
        AuthState:{error,loading},
        traversingOutState:{
            error:travError,
            loading:travLoading,
            data:travData}
    }} = useContext(GlobalStore);
    
    const[userData,setUserData] = useState({});
    const[profileRoute,setProfileRoute] = useState({});

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogOut = ()=> {
        UserLogout()(authDispatch);
      }

      useEffect(() => {
        async function fetchUser () {
            const user = await getLocalProfile();
            if(user){
                setUserData(JSON.parse(user));
            }
        }
        fetchUser();
    }, [])

    useEffect(()=>{
        async function fetchProfile(){
            let res = await getUserProfile();
            setProfileRoute(res)
        }
        fetchProfile();
    },[])

    /**
     * used to request an authentication process from 
     * the server in order for to go another terminal
     * 
     * @param {Object} routeData - Routing data
     */
    const redirectToAnotherTerminal = (routeData)=>{
        userTraversingToAct(routeData)(authDispatch)((res)=>{
            if(res.status === 'Success'){
                var win = window.open(res.data, '_blank');
                win.focus();
            }else{
                toast.error(res.message)
            }
        })
    }
    

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userData?.fname}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">Founder</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userData?.fname} {userData?.mname} !</h6>
                    <DropdownItem className='p-0'>
                        <NavLink 
                            to="#" 
                            onClick={(e)=>{
                                redirectToAnotherTerminal({
                                    belong_to_terminal_name_id:profileRoute?.terminal,
                                    belong_to_terminal_name:profileRoute?.terminal_name,
                                    belong_to_terminal:profileRoute?.sys_terminal_id,
                                    route:profileRoute?.route,
                                })
                            }}
                            className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </NavLink>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    {/* <DropdownItem className='p-0'>
                        <NavLink to="" className="dropdown-item">
                        <i 
                        className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> 
                        <span className="align-middle">Lock screen</span>
                        </NavLink>
                    </DropdownItem> */}
                    <DropdownItem className='p-0'>
                        <a className="dropdown-item" href="/" onClick={handleLogOut}>
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                            <span className="align-middle" data-key="t-logout">Logout</span>
                        </a>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
